import { isTrue } from 'src/common/helpers/UtilHelper';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';

export const useIsJiraWriteBackEnabled = (): boolean => {
	const configurationContext = useConfiguration();

	return isTrue(configurationContext?.configuration?.PLATFORM?.DEV_TOGGLES?.ENABLE_JIRA_WRITE_BACK);
};
